export type Menu = {
  menu: Array<MenuItem>;
};

export type MenuItem = {
  parentId: number | null;
  id: number;
  name: string;
  url: string;
  html: string | null;
  sub: Array<MenuItem> | null;
};

export type MenuProps = {
  menuData: Array<MenuItem> | undefined;
  url: string;
  isMenuOpen: boolean;
  handleOpenMenu: (val: boolean) => void;
  topPosition: number;
};

export const ITEMS_TO_DISPLAY = 5;
